import React, { useState } from "react";

import { Box, Grid } from "@mui/material";

import { editObjectData } from "@aclymatepackages/array-immutability-helpers";
import { LoadingButton, Checkbox, TextField } from "@aclymatepackages/atoms";
import { emailRegExpTest } from "@aclymatepackages/reg-exp";
import { incorrectNameCheck } from "@aclymatepackages/other-helpers";

import PasswordInput from "./PasswordInput";
import OAuthButtons from "./OAuthButtons";

import OrDivider from "../atoms/OrDivider";

const AccountCreationInput = ({
  isNewCompanyAdmin,
  setErrorMsg,
  userLoading,
  initialUserData,
  completePasswordEmailAccountCreation,
  completeOauthAccountCreation,
  cta,
  oauthStacked
}) => {
  const [inputData, setInputData] = useState(initialUserData || {});
  const [honeyPot, setHoneyPot] = useState(false);

  const { email: existingIndividualEmail = "", name: existingIndividualName } =
    initialUserData || {};
  const {
    email = existingIndividualEmail,
    displayName = existingIndividualName,
    password = ""
  } = inputData || {};

  const editInputData = (field) => (value) =>
    editObjectData(setInputData, field, value);

  const onCompletePasswordEmailSignup = async () => {
    if (honeyPot) {
      return console.log("no bots allowed");
    }

    const formattedInputData = {
      ...inputData,
      displayName
    };

    return await completePasswordEmailAccountCreation(formattedInputData);
  };

  // Note: OAuth providers (Google/Microsoft) typically don't provide phone numbers
  // by default. Phone numbers for OAuth users would need to be collected separately
  // in a post-registration step or through user profile settings.

  return (
    <>
      <OAuthButtons
        callback={completeOauthAccountCreation}
        setErrorMsg={setErrorMsg}
        isNewAccount
        stacked={oauthStacked}
      />
      <Grid item>
        <Box position="relative">
          <OrDivider />
        </Box>
      </Grid>
      <Grid item container direction="column" spacing={2}>
        {!existingIndividualName && (
          <Grid item>
            <TextField
              id="user-name-input"
              label="Your Name"
              value={displayName}
              setValue={editInputData("displayName")}
              error={displayName && incorrectNameCheck(displayName)}
              helperText={
                displayName &&
                incorrectNameCheck(displayName) &&
                "You need to have a name with less than 50 characters and it must contain at least one non-numeric character."
              }
              disabled={userLoading}
            />
          </Grid>
        )}
        <Grid item>
          <TextField
            label="Email Address"
            value={email}
            setValue={editInputData("email")}
            id="email-update"
            disabled={!!existingIndividualEmail || userLoading}
          />
        </Grid>
        <Grid item>
          <PasswordInput
            password={password}
            setPassword={editInputData("password")}
            helperText
            disabled={userLoading}
          />
        </Grid>
      </Grid>
      <div
        ref={(el) => el && el.style.setProperty("display", "none", "important")} //This is a weird hack because we always want this component to be hidden since it's a honey pot
      >
        <Checkbox
          name="is-remote"
          tabIndex={-1}
          value={honeyPot}
          editValue={setHoneyPot}
          label="Is this business fully remote"
          autocomplete={false}
        />
      </div>
      <Grid container item spacing={2} justifyContent="center">
        <Grid item>
          <LoadingButton
            id="new-user-submit"
            color="secondary"
            label={isNewCompanyAdmin ? "Join Account" : "Create Account"}
            disabled={
              !emailRegExpTest(email) ||
              !displayName ||
              password.length < 12 ||
              (displayName && incorrectNameCheck(displayName))
            }
            onClick={onCompletePasswordEmailSignup}
            isLoading={userLoading}
          />
        </Grid>
        {cta && <Grid item>{cta}</Grid>}
      </Grid>
    </>
  );
};
export default AccountCreationInput;
